export const Data_Section = 'Register_Section'
export const Account_Section = 'Account_Section'
export const ServiceFees_Section = 'ServiceFees'
export const Admin_Section= "Admin_Section"
export const Stake_Section= "Stake_Section"
export  const Logedin="Logedin"
export const Pooldata="Pooldata"